<template>
  <v-col v-if="!wrapper.hide" class="pt-0 pb-2" cols="12">

    <v-row no-gutters align="center">
      <v-col cols="auto" class="d-flex align-center mr-2">
        <v-icon v-text="wrapper.icon" size="18"></v-icon>
      </v-col>
      <v-col cols="auto">
        {{ wrapper.display }}
      </v-col>
      <v-col cols="0" class="d-flex align-center mx-3">
        <v-progress-linear v-if="wrapper.loading" indeterminate :color="'tertiary'" height="3">
        </v-progress-linear>
        <v-divider v-else />
      </v-col>
    </v-row>
    <v-container v-if="wrapper.loading">
      {{ $t('servicesystem.common_objects.commonterms.searching') }}
    </v-container>
    <v-container v-else-if="wrapper.error" class="error--text">
      {{ wrapper.error && (wrapper.error.code != "ERR_CANCELED") ? 'Error fetching results' : 'Search canceled' }}
    </v-container>
    <v-container v-else-if="!wrapper.list[0]">
      {{ $t('servicesystem.common_objects.fallbackterms.no_items') }}
    </v-container>
    <v-container v-else class="pa-0" fluid>
      <v-row no-gutters>
        <v-col>
          <template v-for="(element) in wrapper.list.slice(0, maxLinesPerWrapper)">
            <SearchItemWrapper :key="wrapper.tag + '-' + element.Id" :wrapper="wrapper" :item="element">
            </SearchItemWrapper>
          </template>

          <v-btn :color="'blue'" text small class="px-4" @click="wrapper.onViewAll(query)">
            {{ $t('servicesystem.common_objects.commonterms.show_more') }}
            <v-icon size="18">mdi-chevron-right</v-icon>
          </v-btn>

        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>


<script>
import SearchItemWrapper from "@/components/Sections/AppSections/SearchItemWrapper.vue";

export default {
  name: "SearchResultWrapperList",
  props: {
    query: String,
    wrapper: Object,
    activeWrapperCount: Number,
  },
  components: {
    SearchItemWrapper,
  },
  mixins: [],

  data() {
    return {};
  },

  mounted() { },

  methods: {
  },

  computed: {
    maxLinesPerWrapper() {
      if (this.activeWrapperCount > 2) {
        return 5;
      } else if (this.activeWrapperCount > 1) {
        return 7;
      } else {
        return 15;
      }
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>